import React, { ReactNode, useCallback } from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';

/**
 * This component is useful if you have components within a TouchTarget that have strange touch/click behavior that you need to prevent
 * bubbling up to a TouchTarget.
 */
export const NoopTouchTarget: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const childrenProvider = useCallback(() => children, [children]);
  return (
    <TouchTarget
      content={childrenProvider}
      behavior={{ type: 'onClick', onClick: () => {} }}
    />
  );
};
